<template lang="pug">
  n-dialog(
    v-model='dialog'
    persistent
    scrollable
    :width='600'
  )
    v-card.py-2.px-1
      v-card-text.text-center.black--text.px-1
        h3 {{ info.room ? info.room.name : '' }}
        h3 {{ $t('total-price') }} : {{ info.bet_amount || 0 }}
        template(
          v-for='(itemCondition,i) in number_conditions'
        )
          .py-2(
            :key='i'
            v-show='dataFilter(itemCondition).length!==0'
          )
            h4 {{ itemCondition.number_type.name }}
            h5 {{ $t('amount') }} : {{ dataFilter(itemCondition).length }}
          v-row(no-gutters)
            v-col(
              v-for=' (item,index) in dataFilterGroupByNumber(dataFilter(itemCondition))'
              :key='index'
              cols=12
              md=12
            ).pa-1
              v-row(
                no-gutters 
                align="center" 
                :style="item.reward_x_unit_amount <= 0 ? 'background:red; color:white;' : ''"
              ).px-1
                v-col(md='2')
                  v-card.d-flex.justify-center.py-2(
                    width='60'
                    flat
                    dark
                    :color='colorNumber(item)'
                  ) {{ item.number }}
                v-col(cols='3' align="center")
                  h5 {{ $t('amount') }}   
                  b {{ item.unit }}
                v-col(cols='3' align="center")
                  h5 {{ $t('price-paid') }}  
                  b(
                    :class='classColor(item)'
                  ) {{ item.avg_reward_x_unit_amount | currency }}
                v-col(cols='3' align="center")
                  h5 {{ $t('reward-stake') }}  
                  b(
                    :class='classColor(item)'
                  ) {{ item.reward_x_unit_amount | currency }}
      v-card-actions
        v-row.mt-3(no-gutters justify='center')
          v-col.px-1(cols='6')
            v-btn(
              block 
              depressed 
              dark 
              color='red' 
              @click='cancel ()'
            ) {{ $t('button.cancel') }}
          v-col.px-1(cols='6')
            v-btn.mb-2.white--text(
              :disabled='Isexpired || submitStatus'
              :loading='submitStatus'
              block 
              depressed
              color='var(--bg-secondary-color)'
              @click='submit ()'
            ) {{ $t('button.confirm') }} {{ countDownTime }}

</template>
<script>  
import { timeStampConvert } from '@/plugins/time'
import { gameRooms as apiGameRooms } from '@/apis'
import * as c from '@/const/setTimeOutConfig' 

export default { 
  data: () => ({
    dialog:false,  
    number_conditions:[],
    info:{}, 
    countDownTime:'',
    expired_timestamp : 0,
    expired_at : 0,
    Isexpired : false, 
    submitStatus : false
  }),  
  methods : {  
    classColor (item) { 
      return item.reward_x_unit_amount <= 0 ? 'white--text' : ''
    },
    colorNumber (item) {
      return item.reward_x_unit_amount <= 0 ? '#1365ff' : '#f7aa0a'
    },

    async submit (){   
      this.$ga.event('Submit', 'ConfirmAddStake', 'GamePage','') 
      this.submitStatus = true

      let entireStake = this.info.list.map(element=>{ 
        return {
        number:element.number,
        number_type_id:element.number_type.id,
        unit:element.unit
        } 
      })

      this.dialog=false 

      let params = {
        stakes : entireStake
      }

      const [err, ,message] = await apiGameRooms.confirmStake(this.$route.query.id,this.info.list_uuid,params)
      
      this.submitStatus = false 
      
      if(err){
        this.$alert('',err,'warning') 
        return
      }
      
      this.$store.dispatch('userProfile/ACTION_WALLET') 
      this.$emit('load')
      this.$alert('',message,'success') 
    },

    async cancel (){
      var entireStake = this.info.list.map(element=>{ 
        return {
          number:element.number,
          number_type_id:element.number_type.id,
          unit:element.unit
        } 
      })

      var data = {
        stakes : entireStake
      }

      await apiGameRooms.cancelStake(this.$route.query.id,this.info.list_uuid,data) 

      this.dialog=false
    },

    openDialog (info,number_conditions){  
      this.Isexpired = false
      this.submitStatus = false 
      this.info = info  
      this.number_conditions = number_conditions
      
      if(!info || !info.expired_at) {
        return 
      }

      this.expired_at = info.expired_at ? timeStampConvert(info.expired_at)/1000 : 0
      this.expired_timestamp = this.expired_at - (Date.now()/1000)     
      this.dialog = true
      
      if(this.expired_timestamp > 0) {
        this.countDownCloseTimer() 
      }
    },

    dataFilterGroupByNumber (items) {
      const groupedItems = Object.values(
        items.reduce((acc, item) => {
          if (!acc[item.number]) {
            acc[item.number] = { 
              ...item, 
              avg_reward_x_unit_amount: item.reward_x_unit_amount / item.unit
            };
          } else {
            acc[item.number].unit += item.unit;
            acc[item.number].reward_x_unit_amount += item.reward_x_unit_amount;
            acc[item.number].avg_reward_x_unit_amount = acc[item.number].reward_x_unit_amount / acc[item.number].unit;
          }

          return acc;
        }, {})
      );
      
      return groupedItems;
    },

    dataFilter (item){
      return this.info.list.filter(x=>x.number_type.id===item.number_type.id) 
    },

    countDownCloseTimer () {     
      setTimeout(() => {
        if(this.expired_timestamp >0 && this.dialog) {    
          var seconds = Math.floor((this.expired_timestamp % 60));
          seconds<10? seconds='0'+seconds : ''
          this.countDownTime =  seconds  
 
          this.expired_timestamp = this.expired_at - (Date.now()/1000)  
          this.countDownCloseTimer() 
        } else { 
          this.Isexpired = true 
          this.countDownTime = ''
          if(!this.submitStatus && this.dialog) {
            setTimeout(()=>{
              this.cancel()
            },500) 
          }
        }
      }, c.COUNTDOWNONESEC)
    },
  } 
}
</script>